<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Token PSE</h3>
        </div>
        <div class="card-body">
            <div class="form-body">
                <div class="row">
                    <div class="col-12" :class="{'has-danger': errors.token_pse_text}">
                        <template v-if="action !== 'update'">
                            <div class="row">
                                <div class="col">
                                    <el-input v-model="form.token_pse_text"
                                              disabled>
                                    </el-input>
                                </div>
                                <div class="col-auto" style="display: flex; padding-left: 0">
                                    <el-button type="primary" slot="append" @click.prevent="action = 'update'">
                                        Editar
                                    </el-button>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row">
                                <div class="col">
                                    <el-input v-model="form.token_pse"></el-input>
                                    <small class="form-control-feedback"
                                           v-if="errors.token_pse"
                                           v-text="errors.token_pse[0]"></small>
                                </div>
                                <div class="col-auto" style="display: flex; padding-left: 0">
                                    <el-button type="primary" @click.prevent="submit" :loading="loading_submit">
                                        Guardar
                                    </el-button>
                                    <el-button slot="append" @click.prevent="action = ''">Cancelar</el-button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'tokenPse',
    data() {
        return {
            loading_submit: false,
            resource: "configurations",
            errors: {},
            form: {},
            action: ''
        };
    },
    async created() {
        await this.initForm();
        await this.getRecord();
    },
    methods: {
        initForm() {
            this.errors = {};
            this.form = {
                token_pse_text: null,
                token_pse: null,
            };
            this.action = '';
        },
        async getRecord() {
            await this.$http.get(`/${this.resource}/get_token_pse`)
                .then(response => {
                    this.form = response.data;
                });
        },
        async submit() {
            this.loading_submit = true;
            await this.$http
                .post(`/${this.resource}/store_token_pse`, this.form)
                .then(response => {
                    this.initForm();
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    } else {
                        this.$message.error(response.data.message);
                    }
                    this.getRecord();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data;
                    } else {
                        console.log(error);
                    }
                })
                .then(() => {
                    this.loading_submit = false;
                });
        },
    }
};
</script>

